import * as THREE from 'three';

const disposeTexture = (tex?: THREE.Texture | null) => {
    if (tex) tex.dispose();
};

const disposeMaterial = (material: THREE.Material) => {
    const m = material as any;
    disposeTexture(m.map);
    disposeTexture(m.lightMap);
    disposeTexture(m.bumpMap);
    disposeTexture(m.normalMap);
    disposeTexture(m.specularMap);
    disposeTexture(m.envMap);
    disposeTexture(m.alphaMap);
    disposeTexture(m.emissiveMap);
    disposeTexture(m.roughnessMap);
    disposeTexture(m.metalnessMap);
    disposeTexture(m.displacementMap);
    material.dispose();
};

export default function disposeThreeObject(obj?: THREE.Object3D | null): void {
    if (!obj) return;

    while (obj.children.length > 0) {
        const child = obj.children[0];
        disposeThreeObject(child);
        obj.remove(child);
    }

    // geometry/material only exist on Mesh/Points/Line
    const hasGeometry = (o: any): o is THREE.Mesh | THREE.Line | THREE.Points => !!(o as any).geometry;
    if (hasGeometry(obj)) (obj as any).geometry?.dispose();

    const hasMaterial = (o: any): o is THREE.Mesh | THREE.Line | THREE.Points => !!(o as any).material;
    if (hasMaterial(obj)) {
        const mat = (obj as any).material;
        Array.isArray(mat) ? mat.forEach(disposeMaterial) : disposeMaterial(mat);
    }
}